<h1 mat-dialog-title>
    {{data.message}}
</h1>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{ 'forms.common.Cancel' | translate}}</button>
</div>